import React from "react";
import {
  Star,
  Heart,
  Users,
  Calendar,
  Award,
  Phone,
  Mail,
  MapPin,
  Clock,
  Shield,
  Gift,
  Video,
  Truck,
  CheckCircle,
} from "lucide-react";
import HeaderComponent from "./Home/HeaderComponent";
import Footer from "./Home/Footer";
import Temple from "../../assets/mahalaxmin-temple-02.jpg";
import Nilesh from "../../assets/nilesh.jpeg";
const AboutUsPage = () => {
  const stats = [
    {
      icon: <Users className="h-8 w-8" />,
      number: "5L+",
      label: "Happy Devotees",
    },
    {
      icon: <Calendar className="h-8 w-8" />,
      number: "50K+",
      label: "Pujas Completed",
    },
    {
      icon: <Star className="h-8 w-8" />,
      number: "4.9",
      label: "Average Rating",
    },
    {
      icon: <Award className="h-8 w-8" />,
      number: "15+",
      label: "Years Experience",
    },
  ];

  const features = [
    {
      icon: <Shield className="h-8 w-8 text-orange-500" />,
      title: "Authentic Rituals",
      description:
        "Traditional pujas performed by verified and experienced pandits following ancient Vedic traditions.",
    },
    {
      icon: <Video className="h-8 w-8 text-orange-500" />,
      title: "Video Recording",
      description:
        "Watch your personalized puja ceremony in high definition video sent directly to your phone.",
    },
    {
      icon: <Gift className="h-8 w-8 text-orange-500" />,
      title: "Blessed Prasad",
      description:
        "Receive blessed prasad and sacred items from the temple delivered to your doorstep.",
    },
    {
      icon: <Truck className="h-8 w-8 text-orange-500" />,
      title: "Pan-India Delivery",
      description:
        "We deliver blessed prasad and puja materials across India with proper care and reverence.",
    },
  ];

  const team = [
    {
      name: "Nilesh Vidyadhar Thanekar",
      role: "Shree Pujak",
      experience: "25+ years",
      specialization: "Vedic Rituals & Abhishek",
      image: "👨‍🦳",
    },
    {
      name: "Kedar Joshi",
      role: "Priest",
      experience: "20+ years",
      specialization: "Traditional Offerings & Naivedya",
      image: "👨‍🦲",
    },
    {
      name: "Akshay Joshi",
      role: "Consultant",
      experience: "15+ years",
      specialization: "Paduka Worship & Special Ceremonies",
      image: "🧙‍♂️",
    },
  ];

  const timeline = [
    {
      year: "2009",
      title: "Temple Establishment",
      description:
        "Shree Mahalaxmi Ambabai temple established in Kolhapur with traditional architecture.",
    },
    {
      year: "2015",
      title: "Digital Initiative",
      description:
        "Started online puja booking services to connect devotees worldwide with the temple.",
    },
    {
      year: "2018",
      title: "Video Services",
      description:
        "Introduced video recording of personalized pujas for distant devotees.",
    },
    {
      year: "2020",
      title: "Pandemic Support",
      description:
        "Provided continuous spiritual support during COVID-19 with contactless services.",
    },
    {
      year: "2023",
      title: "5L+ Devotees",
      description:
        "Reached milestone of serving over 5 lakh devotees across India and abroad.",
    },
  ];

  return (
    <>
      <HeaderComponent />
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50">
        {/* Hero Section */}
        <section className="py-20 px-4 bg-gradient-to-r from-orange-500 to-red-500 text-white">
          <div className="container mx-auto max-w-6xl text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-4xl animate-pulse">
                🪔
              </div>
            </div>
            <h1 className="text-5xl font-bold mb-6">About MahalaxmiPuja</h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
              Connecting devotees worldwide with the divine blessings of Shree
              Mahalaxmi Ambabai through authentic temple rituals, personalized
              pujas, and sacred traditions passed down through generations.
            </p>
            <div className="flex items-center justify-center space-x-8 text-lg">
              <div className="flex items-center">
                <MapPin className="h-6 w-6 mr-2" />
                <span>Kolhapur, Maharashtra</span>
              </div>
              {/* <div className="flex items-center">
                <Calendar className="h-6 w-6 mr-2" />
                <span>Established 2025</span>
              </div> */}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        {/* <section className="py-16 px-4 bg-white">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white mx-auto mb-4 group-hover:scale-110 transition-transform">
                    {stat.icon}
                  </div>
                  <div className="text-4xl font-bold text-gray-800 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Our Story Section */}
        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-800 mb-6">
                  Our Sacred Journey
                </h2>
                <div className="space-y-6 text-gray-600 leading-relaxed">
                  <p>
                    <strong className="text-orange-600">MahalaxmiPuja</strong>{" "}
                    was born from a vision to bring divine blessing to devotees
                    who can not visit physically, in a virtual format, by using
                    modern technology.
                  </p>
                  <p>
                    We believe that distance should never be a barrier to
                    seeking divine blessings. Through our innovative online
                    platform, we bring the sacred rituals of Shree Mahalaxmi
                    Ambabai directly to your homes, maintaining the authenticity
                    and sanctity of traditional temple worship.
                  </p>
                  <p>
                    Our experienced pandits perform each puja with complete
                    dedication and devotion, ensuring that every ritual follows
                    the ancient Vedic traditions. From simple offerings to
                    elaborate ceremonies, we treat each service with equal
                    reverence and care.
                  </p>
                </div>
              </div>
              <div className="relative">
                <img
                  src={Temple}
                  alt="Shree Mahalaxmi Ambabai Temple"
                  className="w-full h-64 rounded-2xl object-cover shadow-xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-16 px-4 bg-white">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                Why Choose MahalaxmiPuja?
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We combine ancient traditions with modern convenience to deliver
                authentic spiritual experiences.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="text-center p-6 rounded-xl hover:shadow-lg transition-all group"
                >
                  <div className="w-16 h-16 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-100 transition-colors">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Process Section */}
        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                How We Serve You
              </h2>
              <p className="text-xl text-gray-600">
                Simple steps to receive divine blessings
              </p>
            </div>

            <div className="grid md:grid-cols-4 gap-8">
              {[
                {
                  step: "1",
                  title: "Choose Service",
                  description:
                    "Select from our range of authentic temple services and pujas",
                  icon: "🙏",
                },
                {
                  step: "2",
                  title: "Book Online",
                  description:
                    "Provide your details and preferred date/time for the ceremony",
                  icon: "📅",
                },
                {
                  step: "3",
                  title: "Puja Performed",
                  description:
                    "Our experienced pandits perform the ritual with your name and gotra",
                  icon: "🕉️",
                },
                {
                  step: "4",
                  title: "Receive Blessings",
                  description:
                    "Get video recording and blessed prasad delivered to your home",
                  icon: "🎁",
                },
              ].map((process, index) => (
                <div key={index} className="text-center relative">
                  <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white font-bold text-xl mx-auto mb-4">
                    {process.step}
                  </div>
                  <div className="text-4xl mb-3">{process.icon}</div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {process.title}
                  </h3>
                  <p className="text-gray-600">{process.description}</p>

                  {/* Connecting Arrow */}
                  {index < 3 && (
                    <div className="hidden md:block absolute top-8 left-full w-full">
                      <div className="w-8 h-0.5 bg-orange-300 transform translate-x-4"></div>
                      <div className="w-0 h-0 border-l-4 border-l-orange-300 border-t-2 border-t-transparent border-b-2 border-b-transparent transform translate-x-12 -translate-y-1"></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Team Section */}
        {/* <section className="py-16 px-4 bg-white">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                Our Sacred Team
              </h2>
              <p className="text-xl text-gray-600">
                Experienced pandits dedicated to serving devotees with devotion
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {team.map((member, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 text-center border border-orange-100 hover:shadow-lg transition-all"
                >
                  <div className="text-6xl mb-4">{member.image}</div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    {member.name}
                  </h3>
                  <p className="text-orange-600 font-semibold mb-2">
                    {member.role}
                  </p>
                  <p className="text-gray-600 mb-2">{member.experience}</p>
                  <p className="text-sm text-gray-500">
                    {member.specialization}
                  </p>
                  <div className="flex justify-center mt-4">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-4 w-4 text-yellow-500 fill-current"
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Head Priest Section */}
        {/* <section className="py-16 px-4 bg-white">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="mb-6">
                  <h2 className="text-4xl font-bold text-gray-800 mt-2 mb-4">
                    Meet Shreepujak
                  </h2>
                </div>

                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6 border border-orange-100">
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">
                      Nilesh Vidyadhar Thanekar
                    </h3>
                    <p className="text-orange-600 font-semibold mb-3">
                      Shreepujak
                    </p>
                    <p className="text-gray-600 leading-relaxed">
                      With over many years of dedicated service to Shree
                      Mahalaxmi Ambabai, Nilesh Vidyadhar Thanekar brings
                      profound spiritual wisdom and authentic Vedic knowledge to
                      every ceremony. He is hereditary Shreepujak of Mahalaxmi
                      Ambabai Devi. His deep understanding of ancient Sanskrit
                      texts and traditional rituals ensures that each puja is
                      performed with utmost devotion and precision.
                    </p>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-blue-800 italic leading-relaxed">
                      "Every puja is a sacred connection between the devotee and
                      the divine. I consider myself blessed to be a medium for
                      these divine blessings and ensure that each ritual carries
                      the pure intentions and prayers of our devotees to
                      Mahalaxmi Ambabai Mata."
                    </p>
                    <p className="text-blue-700 font-semibold mt-2">
                      - Shreepujak Nilesh Vidyadhar Thanekar
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl p-8">
                  <img
                    src={Nilesh}
                    alt="Nilesh Thanekar"
                    className="w-full h-96 rounded-xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-4 -right-4 bg-white rounded-full p-4 shadow-lg">
                    <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white text-2xl">
                      🙏
                    </div>
                  </div>
                </div>

                <div className="absolute -top-4 -left-4 w-8 h-8 bg-orange-300 rounded-full opacity-50"></div>
                <div className="absolute top-1/2 -right-6 w-6 h-6 bg-red-300 rounded-full opacity-40"></div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Values Section */}
        <section className="py-16 px-4 bg-gradient-to-r from-orange-500 to-red-500 text-white">
          <div className="container mx-auto max-w-6xl text-center">
            <h2 className="text-4xl font-bold mb-12">Our Core Values</h2>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  icon: <Heart className="h-12 w-12" />,
                  title: "Devotion",
                  description:
                    "Every puja is performed with complete dedication and spiritual reverence.",
                },
                {
                  icon: <Shield className="h-12 w-12" />,
                  title: "Authenticity",
                  description:
                    "We maintain traditional Vedic practices without compromise on quality.",
                },
                {
                  icon: <Users className="h-12 w-12" />,
                  title: "Service",
                  description:
                    "Our devotees' spiritual satisfaction is our highest priority.",
                },
              ].map((value, index) => (
                <div key={index} className="text-center">
                  <div className="w-24 h-24 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
                    {value.icon}
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{value.title}</h3>
                  <p className="text-lg leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 px-4 bg-white">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                Visit Our Sacred Temple
              </h2>
              <p className="text-xl text-gray-600">
                Experience divine blessings in person
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 border border-orange-100">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">
                    Temple Information
                  </h3>

                  <div className="space-y-4">
                    <div className="flex items-center">
                      <MapPin className="h-6 w-6 text-orange-500 mr-4" />
                      <div>
                        <div className="font-semibold">
                          Shree Mahalaxmi Ambabai Temple
                        </div>
                        <div className="text-gray-600">
                          Mahadwar Road, Kolhapur, Maharashtra 416012
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <Clock className="h-6 w-6 text-orange-500 mr-4" />
                      <div>
                        <div className="font-semibold">Temple Timings</div>
                        <div className="text-gray-600">
                          Daily: 5:00 AM - 10:00 PM
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <Phone className="h-6 w-6 text-orange-500 mr-4" />
                      <div>
                        <div className="font-semibold">Contact Number</div>
                        <div className="text-gray-600">+91 9699588995</div>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <Mail className="h-6 w-6 text-orange-500 mr-4" />
                      <div>
                        <div className="font-semibold">Email</div>
                        <div className="text-gray-600">
                          ambabaimahalaxmipuja@gmail.com
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl p-8 text-center">
                <div className="text-8xl mb-6">🕉️</div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Join Our Community
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Become part of our growing family of devotees who trust us for
                  their spiritual needs. Experience the divine blessings of
                  Shree Mahalaxmi Ambabai from anywhere in the world.
                </p>
                <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-3 rounded-full font-semibold hover:from-orange-600 hover:to-red-600 transition-all transform hover:scale-105 shadow-lg">
                  Start Your Spiritual Journey
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AboutUsPage;
